/********************************************************************
 * Created ON:30/11/2018
 * Created by: Avaya
 * Description: Common error popup component
 * 
 * Revision History:
 * Modification date: 
 * Description:
 **********************************************************************/
import { Component,Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NodeService } from '../../services/node.service';
import { StorageService } from '../../services/storage.service';
import { MuteService } from '../../services/mute.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-errormodal',
  templateUrl: './errormodal.component.html',
  styleUrls: ['./errormodal.component.css']
})
export class ErrormodalComponent implements OnInit {
  @Input() public menuOpen: boolean;
  @Input() public menuClose: boolean;
  public error_message: any; // incoming error message that needs to be displayed
  public allAudioTags: any;
  public isLogin = true;
  public locationPointer = 99;
  public audioUrl = '';
  public closeFocusCounter = 0;
  constructor(public bsModalRef: BsModalRef,
    private nodeService: NodeService,
    private router: Router,
    private storageService: StorageService,
    private muteService: MuteService) { }

  ngOnInit() {
    let localStorageToken = this.storageService.getFromLocalStorage('loginToken');
    if (localStorageToken) {
      this.storageService.addToSessionStorage('loginToken', localStorageToken);
    }
    let loginToken = this.storageService.getFromSessioStorage('loginToken');
    
    if (!loginToken) {
      this.isLogin = false;
    }
  }
  
    /**function to monitor opening and closing of the campus map */
    public menuFun() {
      this.menuOpen = !this.menuOpen;
      this.menuClose = !this.menuClose;
      this.menuOpen ? this.audioUrl = "../../assets/audio/menu/Campus_Map_Page_Welcome.mp3" : this.audioUrl = '';
      this.menuClose ? this.closeFocusCounter = 0 : null;
      this.nodeService.addNode({ menuopen: this.menuOpen });
      if (this.menuOpen) {
        document.body.classList.add('menu-opened');
      }
      else {
        document.body.classList.remove('menu-opened');
        this.audioUrl = ""
      }
  
    }

  homePage() {
    this.errorhideModal();
    this.router.navigate(['']);
    this.locationPointer = null;
    this.menuFun();
  }
  public errorhideModal() {
    this.bsModalRef.hide();
    this.nodeService.addNode({ modalopen: false })
    this.muteService.muteFun();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component/errormodal/errormodal.component.ts